/**
 * 忘れず注文商品リスト出力
 * コンボボックス用
 */
export class ConfirmData {
  confirmDate: string = <string>'';     // 確定日時
  confirmUserId: string = <string>'';   // 確定ユーザID
  confirmUserName: string = <string>''; // 確定ユーザ名
  caption: string = <string>'';         // セレクトボックス表示用
  id: string = <string>'';              // セレクトボックス選択用
}[]